// node_modules
import {
    useCallback
} from "react";
// Types
import { TActionObjectDTO, TSavedQueryTempDTO } from "Types";
// Controllers
import { ActionObjectControllerSingleton } from "Controllers";

export const useActionObjects = (
        selectedCaseId: number | undefined, 
        selectedOriginalTechnologyId: number | undefined, 
        selectedSavedQuery: TSavedQueryTempDTO | undefined, 
        updateSavedQuery: (newSavedQuery: TSavedQueryTempDTO | undefined) => void, 
        duplicateSavedQuery: (selectedOriginalTechnologyId: number | undefined, selectedCaseId: number | undefined, callback: (duplicatedSavedQuery: TSavedQueryTempDTO) => Promise<void>) => Promise<void>)
            : [(value: string, actionGroupId?: string, objectGroupId?: string) => Promise<void>, (value: string, savedQuery: TSavedQueryTempDTO | undefined) => TActionObjectDTO | undefined] => {

    // Logic
    const getActionAndObjectFromValue = (value: string): {action: string, obj: string} | null => {
        // trim & safety-checks
        value = value.trim();
        if (!value) { return null; }

        // split by white-spaces
        const actionObjectSplit: string[] = value.split(" ");

        // safety-checks
        if (actionObjectSplit.length <= 1) { return null; }

        // get action and obj
        const action: string = actionObjectSplit[0].charAt(0).toUpperCase() + actionObjectSplit[0].slice(1);

        let obj: string = actionObjectSplit.slice(1, actionObjectSplit.length).join(" ");
        obj = obj.charAt(0).toUpperCase() + obj.slice(1);

        return { action, obj };
    };

    const getDuplicatedActionObjectFromValueInSavedQuery = useCallback((value: string, savedQuery: TSavedQueryTempDTO | undefined): TActionObjectDTO | undefined => {
        if (!value || !savedQuery || (savedQuery && !savedQuery.actionObjects)) { return undefined; }
        
        const actionObjectFromValue = getActionAndObjectFromValue(value);
        if (!actionObjectFromValue) { return undefined;}

        for (const actionObject of savedQuery.actionObjects) {
            if (actionObject.action.trim().toLowerCase() === actionObjectFromValue.action.trim().toLowerCase() &&
                    actionObject.dobject.trim().toLowerCase() === actionObjectFromValue.obj.trim().toLowerCase()) { 
                return actionObject;
            }
        }
        
        return undefined;
    }, []);

    const addActionObject = async (newActionObjectValue: string, actionSearchTermGroupId?: string, objectSearchTermGroupId?: string): Promise<void> => {
        // safety-checks
        if (!selectedSavedQuery) { return; }

        // safety-checks
        newActionObjectValue = newActionObjectValue.trim();
        if (!newActionObjectValue) { return; }

        // safety-checks
        if (getDuplicatedActionObjectFromValueInSavedQuery(newActionObjectValue, selectedSavedQuery)) { return; }

        const actionObject = getActionAndObjectFromValue(newActionObjectValue);
        // safety-checks
        if (!actionObject ) { return; }

        if (selectedSavedQuery.isUserAdded && selectedSavedQuery.isOwnedByCurrentUser) {
            // create new action object
            const newActionObject = await ActionObjectControllerSingleton.createAsync(selectedSavedQuery.guid, true, actionObject.action, actionObject.obj,
                actionSearchTermGroupId, objectSearchTermGroupId);
            // update action object list in the saved query context
            selectedSavedQuery.actionObjects = [...selectedSavedQuery.actionObjects, newActionObject];
            updateSavedQuery(selectedSavedQuery);
        } else {
            duplicateSavedQuery(selectedOriginalTechnologyId, selectedCaseId, async (duplicatedSavedQuery: TSavedQueryTempDTO): Promise<void> => {
                // safety-checks
                if (!duplicatedSavedQuery) { return; }
                // create new action object
                const newActionObject = await ActionObjectControllerSingleton.createAsync(duplicatedSavedQuery.guid, true, actionObject.action, actionObject.obj,
                    actionSearchTermGroupId, objectSearchTermGroupId);
                // update action object list in the saved query context
                duplicatedSavedQuery.actionObjects = [...duplicatedSavedQuery.actionObjects, newActionObject];
                updateSavedQuery(duplicatedSavedQuery);
            });
        }
    };
    

    return [addActionObject, getDuplicatedActionObjectFromValueInSavedQuery];
};
